<template>
  <div class="admin-complaint-container animated fadeInRight">
    <!-- <el-card class="box-card">
      <div slot="header" class="clearfix flex justify-between">
        <span>查询条件</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="5">
          <el-input v-model="searchForm.complaintNo" placeholder="请输入投诉单号" clearable />
        </el-col>
        <el-col :span="5">
          <el-input v-model="searchForm.contactPhone" placeholder="请输入手机号" clearable />
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-col>
      </el-row>
    </el-card> -->

    <el-card class="box-card margin-top-20">
      <div slot="header" class="clearfix flex justify-between">
        <span>投诉建议</span>
      </div>
      <el-table :data="tableData" border style="width: 100%" v-loading="loading">
        <el-table-column prop="complaintNo" label="投诉单号" align="center" width="160" />
        <el-table-column prop="ownerName" label="投诉人" align="center" />
        <el-table-column prop="contactPhone" label="联系电话" align="center" />
        <el-table-column prop="content" label="投诉内容" align="center" show-overflow-tooltip />
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <el-tag :type="getStatusTag(scope.row.status)" size="small">
              {{ formatStatus(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center" min-width="150" />
        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="margin-top-20" :current-page="pagination.current" :page-sizes="[10, 20, 30, 50]"
        :page-size="pagination.size" :total="pagination.total" layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </el-card>
  </div>
</template>

<script>
import { listComplaintOrders } from '@/api/complaint/adminComplaintApi'
import { getCommunityId } from '@/api/community/communityApi'

export default {
  name: 'AdminComplaintList',
  data() {
    return {
      loading: false,
      searchForm: {
        communityId: '',
        complaintNo: '',
        contactPhone: ''
      },
      tableData: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  created() {
    this.searchForm.communityId = getCommunityId()
    this.getList()
  },
  methods: {
    async getList() {
      try {
        this.loading = true
        const { data, total } = await listComplaintOrders({
          communityId: this.searchForm.communityId,
          page: this.pagination.current,
          row: this.pagination.size
        })
        this.tableData = data
        this.pagination.total = total
      } catch (error) {
        this.$message.error('获取投诉列表失败')
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.pagination.current = 1
      this.getList()
    },
    handleReset() {
      this.searchForm.complaintNo = ''
      this.searchForm.contactPhone = ''
      this.pagination.current = 1
      this.getList()
    },
    handleDetail(row) {
      this.$router.push('/views/complaint/adminComplaintDetail?complaintId=' + row.id)
    },
    handleSizeChange(val) {
      this.pagination.size = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.current = val
      this.getList()
    },
    formatStatus(status) {
      const map = { 0: '待处理', 1: '处理中', 2: '已完成', 3: '已关闭' }
      return map[status] !== undefined ? map[status] : '未知'
    },
    getStatusTag(status) {
      const map = { 0: 'warning', 1: 'primary', 2: 'success', 3: 'info' }
      return map[status] !== undefined ? map[status] : ''
    }
  }
}
</script>

<style lang="scss" scoped>
.admin-complaint-container {
  padding: 20px;

  .margin-top-20 {
    margin-top: 20px;
  }
}
</style>
